import { useMechUtTypes } from 'hooks/useMechUtTypes';
import { useUtComparisonStore } from '../store/useUtComparisonStore';
import { fmt } from '../utils/excelUtils';
import SectionBox from './SectionBox';

/** ③ 요약 통계 카드 */
const SummaryCards = () => {
  const analysisResult = useUtComparisonStore((s) => s.analysisResult);
  const isPerLineMode = useUtComparisonStore((s) => s.isPerLineMode);
  // 조기 반환보다 위에 있어야 훅 순서가 깨지지 않는다
  const utTypes = useMechUtTypes();

  if (!analysisResult) return null;

  const diffRows = analysisResult.filter((r) => r.machineHasDiff).length;

  return (
    <SectionBox no="③" title="요약 통계">
      <div className="summary-grid">
        <div className="summary-card">
          <div className="label">전체 {isPerLineMode ? 'Main/Machine' : 'Machine (라인 포함)'}</div>
          <div className="value">{analysisResult.length}</div>
          <div className="unit">{isPerLineMode ? '행 (Main/Machine)' : '행'}</div>
        </div>
        <div className="summary-card danger">
          <div className="label">차이 발생 행</div>
          <div className="value">{diffRows}</div>
          <div className="unit">행</div>
        </div>
        {utTypes.map((ut) => {
          let totalDiff = 0;
          let diffCount = 0;
          for (const r of analysisResult) {
            const d = r.ut[ut.key];
            if (d && d.diffU !== 0) {
              totalDiff += d.diffU;
              diffCount++;
            }
          }
          const cls = diffCount > 0 ? (totalDiff > 0 ? 'danger' : 'success') : '';
          return (
            <div className={`summary-card ${cls}`} key={ut.key}>
              <div className="label">{ut.label}</div>
              <div className="value">
                {diffCount > 0 ? (totalDiff > 0 ? '+' : '') + fmt(totalDiff, 1) : '±0'}
              </div>
              <div className="unit">차이 ({diffCount}개 Machine)</div>
            </div>
          );
        })}
      </div>
    </SectionBox>
  );
};

export default SummaryCards;
